// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Y31i","buttons":"styles_buttons__3GMTS"};